module.exports = __webpack_public_path__ + "static/img/h4.f729f5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h4.jpg
// module id = 38x5
// module chunks = 0